"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var AppSettings_1 = tslib_1.__importDefault(require("../../apiServices/auth/AppSettings"));
var ExceptionHandler_1 = require("../../models/common/base/ExceptionHandler");
var Types_1 = require("../../api/Types");
var DataBuilder_1 = require("../../builder/DataBuilder");
var FunctionApis_1 = require("../../api/FunctionApis");
var Field_1 = require("../../constants/Field");
var Permissions_1 = require("../../apiServices/rbac/permissions/Permissions");
var PermissionsGroup_1 = require("../../apiServices/rbac/group/PermissionsGroup");
var ModelConstants_1 = require("../../constants/ModelConstants");
var Helper_1 = require("../Helper");
var SceFunction = /** @class */ (function () {
    function SceFunction() {
    }
    SceFunction.prototype.getFunctionType = function (model, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, apiResponse, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTypeDetails(model, typeId, version)];
                    case 1:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceFunction.prototype.deleteFunction = function (modelId, typeId, tags) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var functionApi, apiResponse, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefDeletePermission();
                        if (Helper_1.Helper.isTypeGlobal(tags)) {
                            throw new Error("Cannot delete a global Type");
                        }
                        functionApi = new FunctionApis_1.FunctionApis();
                        return [4 /*yield*/, functionApi.deleteFunction(modelId, typeId)];
                    case 1:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceFunction.prototype.getFunction = function (modelId, typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var functionApi, apiResponse, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        functionApi = new FunctionApis_1.FunctionApis();
                        return [4 /*yield*/, functionApi.getFunction(modelId, typeId)];
                    case 1:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceFunction.prototype.saveFunction = function (model, modelJson, tags) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var functionApi, apiResponse, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefWritePermission();
                        if (Helper_1.Helper.isTypeGlobal(tags)) {
                            throw new Error("Cannot save or update a global Type");
                        }
                        functionApi = new FunctionApis_1.FunctionApis();
                        return [4 /*yield*/, functionApi.saveFunction(model, modelJson)];
                    case 1:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceFunction.prototype.importFunctionTypes = function (jsons) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tenentSpecificFunctionTypes, summary, typesApi, mapPromises;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyTypeDefReadWrite();
                        tenentSpecificFunctionTypes = lodash_1.map(jsons, function (json) {
                            var jsonTags = json[Field_1.FIELD.TAGS] ? json[Field_1.FIELD.TAGS] : [];
                            json[Field_1.FIELD.TYPEID] = Helper_1.Helper.updateTenantSpecificTypeId(json[Field_1.FIELD.TYPEID], jsonTags, false);
                            json[Field_1.FIELD.TAGS] = Helper_1.Helper.updateTenantSpecificTags(jsonTags);
                            return json;
                        });
                        summary = {
                            successDetails: [],
                            failureDetails: []
                        };
                        typesApi = new Types_1.Types();
                        mapPromises = lodash_1.map(tenentSpecificFunctionTypes, function (functionType) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var verificationResult, summaryDetailsReason, summaryStatus, dataOut, response, summaryDetails;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, typesApi.verifyModelUniqueness(functionType[Field_1.FIELD.MODEL], functionType[Field_1.FIELD.TYPEID], functionType[Field_1.FIELD.VERSION], ModelConstants_1.ModelConstants.AssetMonitorModel)];
                                    case 1:
                                        verificationResult = _a.sent();
                                        summaryDetailsReason = ["Conflict. Type with typeId " + functionType[Field_1.FIELD.TYPEID] + " already exist or it is marked as deleted "];
                                        summaryStatus = "Failure";
                                        dataOut = {};
                                        if (!((verificationResult.isUnique) && (!verificationResult.isDeleted))) return [3 /*break*/, 3];
                                        delete functionType[Field_1.FIELD.ISDELETED];
                                        return [4 /*yield*/, this.saveFunction(functionType[Field_1.FIELD.MODEL], functionType, functionType[Field_1.FIELD.TAGS]).catch(function (error) {
                                                summaryDetailsReason = [_this.handleServerError(error)];
                                            })];
                                    case 2:
                                        response = _a.sent();
                                        if (response) {
                                            dataOut = response.details;
                                            summaryDetailsReason = ["Saved successfully"];
                                            summaryStatus = "Success";
                                        }
                                        _a.label = 3;
                                    case 3:
                                        summaryDetails = {
                                            status: summaryStatus,
                                            reason: summaryDetailsReason,
                                            dataIn: {
                                                name: functionType[Field_1.FIELD.NAME],
                                                model: functionType[Field_1.FIELD.MODEL],
                                                typeId: functionType[Field_1.FIELD.TYPEID],
                                                version: functionType[Field_1.FIELD.VERSION]
                                            },
                                            dataOut: dataOut
                                        };
                                        if (summaryDetails.status === "Success") {
                                            summary.successDetails.push(summaryDetails);
                                        }
                                        else {
                                            summary.failureDetails.push(summaryDetails);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(mapPromises)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, summary];
                }
            });
        });
    };
    SceFunction.prototype.getFunctionsList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var functionApi, apiResponse, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        functionApi = new FunctionApis_1.FunctionApis();
                        return [4 /*yield*/, functionApi.getFunctionsList()];
                    case 1:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: apiResponse.data
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceFunction.prototype.verifyFunctionExists = function (typeId, name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var functionApi, response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        functionApi = new FunctionApis_1.FunctionApis();
                        return [4 /*yield*/, functionApi.verifyFunctionExists(typeId, name)];
                    case 1:
                        response = _a.sent();
                        result = {
                            details: response.data,
                            status: 200,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceFunction.prototype.getTypeDetails = function (model, typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var types, apiResponse, result, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        types = new Types_1.Types();
                        return [4 /*yield*/, types.getTypeDetails(model, typeId, version)];
                    case 2:
                        apiResponse = _a.sent();
                        result = {
                            status: apiResponse.status,
                            details: DataBuilder_1.DataBuilder.buildFunctionType(apiResponse.data)
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_1 = _a.sent();
                        throw new Error(this.handleFunctionTypeError(error_1));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceFunction.prototype.getFunctionTypes = function (typeInformation) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var exceptions, apiResponses, types, mapPromises, functions, result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        exceptions = [];
                        apiResponses = [];
                        types = new Types_1.Types();
                        mapPromises = lodash_1.map(typeInformation, function (typeInfo) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var apiResponse;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, types.getTypeDetails(typeInfo.model, typeInfo.typeId, typeInfo.version)
                                            .catch(function (error) {
                                            exceptions.push(error);
                                        })];
                                    case 1:
                                        apiResponse = _a.sent();
                                        if (apiResponse) {
                                            apiResponses.push(apiResponse);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(mapPromises)];
                    case 1:
                        _a.sent();
                        if (exceptions.length > 0) {
                            throw new Error(JSON.stringify({ "Error": exceptions }));
                        }
                        functions = lodash_1.map(apiResponses, function (response) {
                            var data = response.data;
                            delete data[Field_1.FIELD.ISDELETED];
                            return data;
                        });
                        result = {
                            status: apiResponses[0].status,
                            details: functions
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceFunction.prototype.handleFunctionTypeError = function (error) {
        var exceptionHandler = new ExceptionHandler_1.ExceptionHandler();
        return JSON.stringify(exceptionHandler.buildExceptionFromError(error));
    };
    SceFunction.prototype.handleServerError = function (error) {
        var exceptionHandler = new ExceptionHandler_1.ExceptionHandler();
        return JSON.stringify(exceptionHandler.parseError(error));
    };
    return SceFunction;
}());
exports.SceFunction = SceFunction;
//# sourceMappingURL=SceFunction.js.map